import clsx from 'clsx';
import React, {useCallback} from 'react';
import {useMatch} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import BackButton from '@/components/brand-header/child-components/back-button/BackButton';
import {useBreadcrumbsBack} from '@/components/brand-header/child-components/breadcrumbs-header';
import useOffPlatformBreadcrumbItems from '@/components/brand-header/child-components/breadcrumbs-header/hooks/useOffPlatformBreadcrumbItems';
import Breadcrumbs from '@/components/breadcrumbs';
import {MenuPopularPaysLogo} from '@/components/unusual-icons';
import useGoBack from '@/hooks/use-go-back';
import styles from './OffPlatformHeader.module.scss';

function OffPlatformHeader() {
  const isBaseRoute = useMatch(`${ROUTES.OFF_PLATFORM_REVIEW}/:campaignId`);
  const breadcrumbItems = useOffPlatformBreadcrumbItems();
  const breadcrumbsBackDestination = useBreadcrumbsBack();
  const tryGoBack = useGoBack();

  const hasBreadcrumbs = (breadcrumbItems?.length ?? 0) > 0;
  const showBreadcrumbs = !isBaseRoute && hasBreadcrumbs;

  const handleBack = useCallback(() => {
    tryGoBack(breadcrumbsBackDestination ?? undefined);
  }, [tryGoBack, breadcrumbsBackDestination]);

  return (
    <div
      className={clsx(styles.header, {
        // On detail routes (where breadcrumbs render), the ContentSubmissionSubHeader
        // below already draws the separating line between header chrome and page
        // content. Drop our own border to avoid a visible double line.
        [styles.headerNoBorder]: showBreadcrumbs,
      })}
    >
      {showBreadcrumbs ? (
        <>
          <BackButton onBack={handleBack} />
          <Breadcrumbs items={breadcrumbItems ?? []} />
        </>
      ) : (
        <MenuPopularPaysLogo height={32} />
      )}
    </div>
  );
}

export default OffPlatformHeader;
